module.exports = __webpack_public_path__ + "static/media/lizard_ladies_strap_white.6ce11ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lizard_ladies_strap_white.png
// module id = 119
// module chunks = 0